<div style="width: 100%;">
  <mat-tab-group animationDuration="0ms" style="width: 100%" [selectedIndex]="selected" (selectedIndexChange)="go($event)">
    <mat-tab label="Basic">
      <div  class="box">
        <app-basic></app-basic>
      </div>
    </mat-tab>
    <mat-tab label="Personal">
      <div  class="box">
        <app-personal></app-personal>
      </div>
    </mat-tab>
    <mat-tab label="Experience">
      <div  class="box">
        <app-experience></app-experience>
      </div>
    </mat-tab>
    <mat-tab label="Professional">
      <div class="box">
        <app-professional></app-professional>
      </div>
    </mat-tab>
    <mat-tab label="Your data">
      <div class="box">
        <app-data-privacy></app-data-privacy>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>